import * as React from 'react';
import styles from './index.scss';

type Props = {
  iconSize?: number;
  iconColor?: string;
  iconPadding?: number;
  onClick?: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
  isExpanded: boolean;
  controlBlockStyle?: React.CSSProperties;
  useArrowIcon?: boolean;
};

export function ExpandButton({
  iconSize = 15,
  iconColor = '#FFFFFF',
  iconPadding = 4,
  onClick,
  onTouchStart,
  isExpanded,
  controlBlockStyle = { padding: 4 },
  useArrowIcon = false
}: Props) {
  return (
    <div
      id={isExpanded ? 'collapse' : 'expand'}
      onTouchStart={onTouchStart}
      onClick={onClick}
      style={controlBlockStyle}
    >
      <div
        style={{
          height: iconSize + iconPadding * 2,
          width: iconSize + iconPadding * 2,
          padding: iconPadding
        }}
        className={styles.expandButton}
      >
        {isExpanded ? (
          <CollapseIcon
            useArrowIcon={useArrowIcon}
            iconColor={iconColor}
            iconSize={iconSize}
          />
        ) : (
          <ExpandIcon
            useArrowIcon={useArrowIcon}
            iconColor={iconColor}
            iconSize={iconSize}
          />
        )}
      </div>
    </div>
  );
}

function ExpandIcon({
  useArrowIcon,
  iconColor,
  iconSize
}: {
  useArrowIcon: boolean;
  iconColor: string;
  iconSize: number;
}) {
  return useArrowIcon ? (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M11.5209581,7.46107784 L6.2754491,2.21556886 C5.97005988,1.92814371 5.50299401,1.92814371 5.21556886,2.21556886 C4.92814371,2.50299401 4.92814371,2.97005988 5.21556886,3.2754491 L9.94011976,8 L5.21556886,12.7245509 C4.92814371,13.011976 4.92814371,13.497006 5.21556886,13.7844311 C5.50299401,14.0718563 5.97005988,14.0718563 6.2754491,13.7844311 L11.5209581,8.52095808 C11.8083832,8.23353293 11.8083832,7.76646707 11.5209581,7.46107784 Z"
          id="Arrow"
          fill={iconColor}
          fill-rule="nonzero"
          transform="translate(8.368263, 8.000000) rotate(-90.000000) translate(-8.368263, -8.000000) "
        />
      </g>
    </svg>
  ) : (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 466 466"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(55.000000, 54.000000)"
        fill={iconColor}
        fill-rule="nonzero"
      >
        <path
          d="M51,229.5 L0,229.5 L0,357 L127.5,357 L127.5,306 L51,306 L51,229.5 Z M0,127.5 L51,127.5 L51,51 L127.5,51 L127.5,0 L0,0 L0,127.5 Z M306,306 L229.5,306 L229.5,357 L357,357 L357,229.5 L306,229.5 L306,306 Z M229.5,0 L229.5,51 L306,51 L306,127.5 L357,127.5 L357,0 L229.5,0 Z"
          id="Shape"
          fill={iconColor}
        />
      </g>
    </svg>
  );
}

function CollapseIcon({
  useArrowIcon,
  iconColor,
  iconSize
}: {
  useArrowIcon: boolean;
  iconColor: string;
  iconSize: number;
}) {
  return useArrowIcon ? (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M11.5209581,7.46107784 L6.2754491,2.21556886 C5.97005988,1.92814371 5.50299401,1.92814371 5.21556886,2.21556886 C4.92814371,2.50299401 4.92814371,2.97005988 5.21556886,3.2754491 L9.94011976,8 L5.21556886,12.7245509 C4.92814371,13.011976 4.92814371,13.497006 5.21556886,13.7844311 C5.50299401,14.0718563 5.97005988,14.0718563 6.2754491,13.7844311 L11.5209581,8.52095808 C11.8083832,8.23353293 11.8083832,7.76646707 11.5209581,7.46107784 Z"
          id="Arrow"
          fill={iconColor}
          fill-rule="nonzero"
          transform="translate(8.368263, 8.000000) rotate(90.000000) translate(-8.368263, -8.000000) "
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 466 466"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(54.000000, 54.000000)"
        fill={iconColor}
        fill-rule="nonzero"
      >
        <path
          d="M0,280.5 L76.5,280.5 L76.5,357 L127.5,357 L127.5,229.5 L0,229.5 L0,280.5 Z M76.5,76.5 L0,76.5 L0,127.5 L127.5,127.5 L127.5,0 L76.5,0 L76.5,76.5 Z M229.5,357 L280.5,357 L280.5,280.5 L357,280.5 L357,229.5 L229.5,229.5 L229.5,357 Z M280.5,76.5 L280.5,0 L229.5,0 L229.5,127.5 L357,127.5 L357,76.5 L280.5,76.5 Z"
          id="Shape"
          fill={iconColor}
        />
      </g>
    </svg>
  );
}
